import AppLayout from '../layout/AppLayout';
import Store from '../pages/store/home';
import {AppRouteConfig} from './route.types';

export const storeRoutes: AppRouteConfig[] = [
  {
    path: 'store',
    element: AppLayout,
    children: [{path: ':supplier_id/:guid', element: Store}],
  },
];
